import React, { useState } from "react";
import {
  FormWrapperInputComponent,
  FormWrapperItem,
} from "../../../../../common/component/Index";
import CheckboxGroup from "antd/lib/checkbox/Group";
import { cloneDeep } from "lodash";
import { TARGET_LANGUAGE_DATA } from "constants/Define";

const AutoTranslateField = (props) => {
  const { onChange = () => {}, languageCode, targetLanguage } = props;
  const targetLanguageData = TARGET_LANGUAGE_DATA.filter(el => el.value !== languageCode);

  //! State
  const [data, setData] = useState([]);

  //! Function
  const onChangeTargetLanguage = (value) => {
    onChange('targetLanguage', value)
    return setData(value);
  };

  const ignoreTranslate = ["ko-KR", "zh-CN"];

  if (ignoreTranslate.includes(languageCode)) return <div />;

  //! Render
  return (
    <FormWrapperInputComponent
      className="auto-translate-field"
      labelTitle={"Lựa chọn thêm ngôn ngữ mong muốn được auto translate"}
    >
      <CheckboxGroup
        options={
          data.sourceLanguage === "en-US"
            ? targetLanguageData.filter((item) => item.value !== "en-US")
            : targetLanguageData
        }
        value={targetLanguage}
        onChange={(checkedValue) => onChangeTargetLanguage(checkedValue)}
      />
    </FormWrapperInputComponent>
  );
};

export default AutoTranslateField;
